import { Helmet } from 'react-helmet'
import { useState } from 'react'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const infoItems = [
  { label: 'First Name', value: 'Muhammad' },
  { label: 'Last Name', value: 'Usman' },
  { label: 'Birth Date', value: '13 Sep 2002' },
  { label: 'Nationality', value: 'Pakistani' },
  { label: 'Languages', value: 'English, Urdu' },
  { label: 'Experience', value: '3+ Years' },
  { label: 'Location', value: 'Faisalabad, PK' },
  { label: 'Freelance', value: 'Available ✓' },
  {
    label: 'Phone',
    value: <a href="tel:+923007588836">+92 300 7588836</a>,
  },
  {
    label: 'Email',
    value: <a href="mailto:usmanarif2913@gmail.com">usmanarif2913@gmail.com</a>,
  },
]

const education = [
  {
    year: '2020 – 2024',
    degree: 'BS Computer Science',
    institution: 'University of Agriculture Faisalabad (UAF)',
    score: 'CGPA 2.9 / 4.0',
    desc: 'UAF (est. 1906) is Pakistan\'s largest university by area at 2,550 acres. The CS department offers a comprehensive curriculum covering AI, Networking, Software Engineering, and Database Systems.',
  },
  {
    year: '2018 – 2020',
    degree: 'Intermediate (FSc / ICS)',
    institution: 'Chishti Group of Colleges, Faisalabad',
    score: '905 / 1100',
    desc: 'A private institution known for its focus on commerce and computer science education. It was here that my passion for the field was ignited, steering me towards a career in technology.',
  },
  {
    year: '2016 – 2018',
    degree: 'Matric',
    institution: 'Govt. New Colony High School, Faisalabad',
    score: '922 / 1100',
    desc: 'Established in 1969, located at Shahi Chowk, Ghulam Muhammad Abad. The school has a longstanding reputation for academic excellence with ~2,220 students and 46 teachers.',
  },
]

export default function About() {
  const [openEdu, setOpenEdu] = useState(0)

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Usman Arif | About Me</title>
        <meta name="description" content="Muhammad Usman Arif | Full Stack Developer" />
        <meta name="keywords" content="usmanarif, Muhammad Usman Arif, about me" />
      </Helmet>

      <div id="about-section" data-aos="fade-right">
        {/* ── Heading ── */}
        <div className="section-heading">
          <span className="section-tag">Who I Am</span>
          <h2>About <span className="gradient-text">Me</span></h2>
          <div className="heading-bar" />
        </div>

        <div className="row g-4 pb-3">
          {/* ── Left: Bio + Info Grid ── */}
          <div className="col-12 col-xl-5">
            <p className="about-bio">
              Hello, I'm Usman — a passionate full-stack developer with 3+ years of hands-on
              experience building modern web and mobile applications. I thrive on turning complex
              ideas into clean, scalable solutions using the MERN stack and beyond.
            </p>

            <div className="info-grid">
              {infoItems.map((item, i) => (
                <div className="info-item" key={i}>
                  <span className="info-label">{item.label}</span>
                  <span className="info-value">{item.value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* ── Right: Education Timeline ── */}
          <div className="col-12 col-xl-7">
            <h3
              style={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontWeight: 700,
                fontSize: '1.25rem',
                color: 'var(--text-primary)',
                marginBottom: '1.5rem',
              }}
            >
              Education
            </h3>

            <div className="edu-timeline">
              {education.map((edu, i) => {
                const isOpen = openEdu === i
                return (
                  <div className="edu-item" key={i}>
                    <div className="edu-year">
                      <CalendarMonthOutlinedIcon style={{ fontSize: 13 }} />
                      {edu.year}
                    </div>
                    <div
                      className={`edu-card${isOpen ? ' edu-card--open' : ''}`}
                      onClick={() => setOpenEdu(isOpen ? null : i)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => e.key === 'Enter' && setOpenEdu(isOpen ? null : i)}
                    >
                      <div className="edu-card-header">
                        <div>
                          <h5>{edu.degree}</h5>
                          <span className="edu-institution">{edu.institution}</span>
                        </div>
                        <div className="edu-card-right">
                          <span className="edu-score">{edu.score}</span>
                          <span className={`edu-chevron${isOpen ? ' rotated' : ''}`}>
                            <ExpandMoreIcon style={{ fontSize: 18 }} />
                          </span>
                        </div>
                      </div>
                      {isOpen && (
                        <p className="edu-desc">{edu.desc}</p>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
